import AuthLayout from "layouts/AuthLayout";
import { ForgotPasswordPage } from "pages/accounts-onboarding/forgot-password";
import type { ForgotPasswordModel } from "pages/accounts-onboarding/models";
import React from "react";

const ForgotPasswordRoute = () => {
	const initialValues: ForgotPasswordModel = {
		email: ""
	};

	return (
		<AuthLayout>
			<ForgotPasswordPage initialValues={initialValues} />
		</AuthLayout>
	);
};

export default ForgotPasswordRoute;
